/** Opciones de vigencia al generar licencias */
export type VigenciaPreset =
  | '30'
  | '90'
  | '180'
  | '365'
  | '730'
  | '1095'
  | 'custom'
  | 'unlimited';

export const VIGENCIA_PRESETS: { value: VigenciaPreset; label: string; days?: number }[] = [
  { value: '30', label: '30 días', days: 30 },
  { value: '90', label: '3 meses (90 días)', days: 90 },
  { value: '180', label: '6 meses', days: 180 },
  { value: '365', label: '1 año', days: 365 },
  { value: '730', label: '2 años', days: 730 },
  { value: '1095', label: '3 años', days: 1095 },
  { value: 'custom', label: 'Personalizado (días)' },
  { value: 'unlimited', label: 'Sin vencimiento' },
];

export function diasDesdePreset(preset: VigenciaPreset, customDays: number): number | null {
  if (preset === 'unlimited') return null;
  if (preset === 'custom') {
    const d = Math.floor(Number(customDays));
    return d > 0 ? d : null;
  }
  return Number(preset);
}

/** ISO de vencimiento; `undefined` = licencia perpetua */
export function calcularExpiresAt(preset: VigenciaPreset, customDays: number): string | undefined {
  const dias = diasDesdePreset(preset, customDays);
  if (dias == null) return undefined;
  return new Date(Date.now() + dias * 86_400_000).toISOString();
}

export function formatearFechaVencimiento(iso?: string | null): string {
  if (!iso) return 'Sin vencimiento';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
}
